//import styles from './Layout.module.css';
import React from 'react'
import { Header, Footer } from '../../components';
import PageTransition from '../PageTransition/PageTransition';

import * as containerStyles from "./Layout.module.css"

export default function Layout({ children, location = {} }) {
  return (
    <div className={`${containerStyles.container} overflow-x-hidden`}>
      <Header />
      <div className="w-full fixed h-40 top-0 z-[30] pointer-events-none">
        <div className="w-full header-blur backdrop-blur-lg header-blur absolute h-32 top-0 z-[31] pointer-events-none"></div>
        <div className="w-full header-blur backdrop-blur-md absolute h-24 top-0 z-[31] pointer-events-none"></div>
        <div className="w-full header-blur backdrop-blur-sm absolute h-16 top-0 z-[31] pointer-events-none"></div>
      </div>
      <main className="pt-18">
        <PageTransition location={location}>
          {children}
        </PageTransition>
      </main>
      <Footer />
    </div>
  );
}
